'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.simpleNonRequiredDate = exports.simpleRequiredDate = undefined;
var _wavfichacertaFichacertaUtils = require('@bit/wavfichacerta.fichacerta.utils.validators');
var _wavfichacertaFichacertaUtils2 = require('@bit/wavfichacerta.fichacerta.utils.formatters');
var _wavfichacertaFichacertaUtils3 = require('@bit/wavfichacerta.fichacerta.utils.normalizers');
var sizes = {
  generalMedium: 'col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6'
};
var simpleRequiredDate = exports.simpleRequiredDate = function simpleRequiredDate(_ref) {
  var name = _ref.name,
    label = _ref.label,
    _ref$validate = _ref.validate,
    validate = _ref$validate === undefined ? _wavfichacertaFichacertaUtils.validateDate : _ref$validate,
    _ref$size = _ref.size,
    size = _ref$size === undefined ? sizes.generalMedium : _ref$size;
  return {
    name: name,
    label: label,
    size: size,
    isRequired: true,
    type: 'maskedText',
    validate: validate,
    normalize: _wavfichacertaFichacertaUtils3.date,
    format: _wavfichacertaFichacertaUtils2.formatDateToBR,
    props: {
      regex: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
    }
  };
};
var simpleNonRequiredDate = exports.simpleNonRequiredDate = function simpleNonRequiredDate(_ref2) {
  var name = _ref2.name,
    label = _ref2.label,
    _ref2$size = _ref2.size,
    size = _ref2$size === undefined ? sizes.generalMedium : _ref2$size,
    _ref2$warnDate = _ref2.warnDate,
    warnDate = _ref2$warnDate === undefined ? _wavfichacertaFichacertaUtils.validateDate : _ref2$warnDate;
  return {
    name: name,
    label: label,
    size: size,
    isRequired: false,
    type: 'maskedText',
    value: "",
    normalize: _wavfichacertaFichacertaUtils3.date,
    format: _wavfichacertaFichacertaUtils2.formatDateToBR,
    warn: function warn(value) {
      return value !== undefined ? warnDate(value) : value;
    },
    hasValidation: true,
    props: {
      regex: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
    }
  };
};